import { Component, OnInit, Input } from '@angular/core';
import { take } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

import {
  BanksCalculator,
  InbankCaclulationsData,
  InbankConfigData,
  InbankService,
  TranslateDirective,
} from '@speedy/core';

import { CurrencyComponent } from '../../../../../../shared/components/currency/currency.component';
import { CalculatorService } from '../../../services/calculator.service';

@Component({
  selector: 'app-inbank-calculator',
  templateUrl: './inbank-calculator.component.html',
  styleUrls: ['./inbank-calculator.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    TranslateDirective,
    ReactiveFormsModule,
    FormsModule,
    CurrencyComponent,
    MatProgressSpinner,
  ],
})
export class InbankCalculatorComponent implements OnInit {
  @Input() productPrice!: number;

  loanPeriod!: number | undefined;
  loanPeriods!: Array<number> | undefined;
  monthlyPayment!: string;
  loadingPayment!: boolean;

  constructor(
    protected inbankService: InbankService,
    protected calculatorService: CalculatorService,
  ) {}

  async ngOnInit() {
    try {
      const response = await this.inbankService.getInbankConfigData();
      const configData: InbankConfigData = JSON.parse(response);
      this.loanPeriods = configData.parameters?.period_options;
      this.loanPeriod = configData.parameters?.period_options[0];
      this.changePeriod(this.loanPeriod as number);
    } catch (error) {
      console.error(error);
    }
  }

  public changePeriod(period: number) {
    this.loadingPayment = true;
    this.calculatorService
      .calculatePaymentByPeriod(BanksCalculator.Inbank, period, this.productPrice)
      .pipe(take(1))
      .subscribe((response: string) => {
        const data: InbankCaclulationsData = JSON.parse(response);
        this.monthlyPayment = data.payment_amount_monthly;
        this.loadingPayment = false;
      });
  }
}
